import React from "react";

export const SingleProductDescriptionFocusedPrice = ({
  product,
  isGiftCardProduct,
  isRetailMerchant,
}: any) => {
  const formatPrice = (price: number) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    }).format(price / 100);
  };

  if (!product.available) {
    return <span className="self-start pt-[2px] font-medium">Unavailable</span>;
  }

  return (
    <span data-testid="product-price" className="pt-[3px] text-sm font-medium">
      {!isGiftCardProduct ? formatPrice(product.price) : "Custom Value"}
    </span>
  );
};
